import { useNavigate } from "react-router-dom";
import SupermarketAdventureHost from "./SupermarketAdventureHost";

const FunWithNumbers = () => {
  const navigate = useNavigate();
  return <SupermarketAdventureHost onBack={() => navigate("/profile")} />;
};

export default FunWithNumbers;


